// extracted by mini-css-extract-plugin
export default {"text":"confirmation_text__fjVGt"};